export type SocialMediaPlatformInfo = {
  Id: string;
  Name: string;
  Icon: string;
};

export function newSocialMediaPlatform(): SocialMediaPlatformInfo[] {
  return [
    {
      Id: "",
      Name: "",
      Icon: "",
    },
  ];
}
